export default __webpack_public_path__ + "static/media/MP5_1.1fa96b23.png";